module.exports = __webpack_public_path__ + "static/media/fail.8331ac55.svg";